// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__XVdu+","titleContainer":"LoginPage_titleContainer__5aWar","appTitle":"LoginPage_appTitle__1hbd2"};